import type { NextApiRequest, NextApiResponse } from "next";
import { TRPCError } from "@trpc/server";
import { getHTTPStatusCodeFromError } from "@trpc/server/http";
import { z } from "zod";
import { getError, RemiErrorDeprecated } from "@remi/error";
import { RnStatusWarning } from "@remi/icons/next";
import { remiLogger } from "@remi/logging";

import { displayToast } from "~/components/ui/sonner";

/**
 * Handle thrown errors from the api
 */
export function handleApiError(err: unknown, res: NextApiResponse, _req: NextApiRequest) {
  if (err instanceof z.ZodError) {
    return res.status(400).send({
      message: err.issues,
    });
  }
  if (err instanceof TRPCError) {
    const code = getHTTPStatusCodeFromError(err);
    if (err.cause instanceof z.ZodError) {
      return res.status(code).send({ message: JSON.stringify(err.message) });
    }
    return res.status(code).send({ message: err.message });
  } else if (err instanceof RemiErrorDeprecated) {
    return res.status(500).send({ message: err.message });
  }

  // Unknown errors (e.g. RemiAppError, RemiServiceError, plain Error) would
  // otherwise 500 silently; capture them so incidents surface in logs/Sentry.
  remiLogger.captureError(getError(err));
  return res.status(500).send({ message: "Internal Server Error" });
}

export const onErrorToast = (err: unknown) => {
  const message = err instanceof Error ? err.message : "Unknown Error";
  displayToast({
    title: "Error",
    description: message,
    variant: "error",
    icon: <RnStatusWarning size="md" />,
  });
};
